<template>
  <div class="grid h-full" style="grid-template-columns: 1fr 3fr">
    <div>
      <ul class="flex items-center gap-x-4 border-b p-2.5">
        <strong>{{ state.model?.name }}</strong>
        <el-button
          type="primary"
          plain
          link
          v-if="!state.search"
          @click="state.showEdit = true"
        >
          <template #icon>
            <el-icon :size="22" class="font-bold">
              <Edit />
            </el-icon>
          </template>
        </el-button>
      </ul>
      <div class="grid grid-cols-2 gap-2 p-2.5">
        <c_cell title="日期" :value="state.model?.date" />
        <c_cell
          title="时间"
          :value="
            $dayjs(state.model?.start_time, 'HH:mm:ss').format('HH:mm') +
            ' ~ ' +
            $dayjs(state.model?.end_time, 'HH:mm:ss').format('HH:mm')
          "
        />
        <c_cell title="类型">
          <template #default>
            <c_status
              arrName="Meeting_Schedule_Type"
              :value="state.model?.type"
              class="m-auto"
              showBg
              :key="state.model?.type"
            />
          </template>
        </c_cell>
        <c_cell title="是否全员日程" :value="state.model?.is_all_personnel" />
        <c_cell title="是否需要签到" :value="state.model?.is_need_signup" />
        <c_cell title="是否网站显示" :value="state.model?.is_site_show" />
        <c_cell
          title="说明"
          :value="state.model?.intro"
          style="grid-column: 1/3"
          class="!items-start"
        />
        <div
          class="flex items-end text-gray-400 text-xs gap-x-2"
          style="grid-column: 1/3"
        >
          <text class="text-sm text-gray-600">
            {{ state.model?.add_admin_name }}
          </text>
          <text>{{ state.model?.add_department_name }}</text>
          <text class="ml-1">{{ state.model?.create_time }} 创建</text>
        </div>
      </div>
    </div>
    <div class="flex flex-col overflow-hidden p-2 bg-white">
      <div class="flex px-5">
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 0
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 0"
        >
          议程管理
        </li>
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 1
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 1"
        >
          人员管理
        </li>
        <li
          class="px-5 py-2 text-sm rounded-t-lg cursor-pointer flex items-center gap-x-1 text-gray-500"
          :class="
            state.nav_index == 2
              ? 'bg-gray-100 font-bold  text-gray-800'
              : ' hover:!text-gray-800 font-bold'
          "
          @click="state.nav_index = 2"
        >
          坐席管理
        </li>
      </div>
      <div class="flex-1 rounded-lg bg-gray-100 flex overflow-hidden">
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 0 && state.model?.id"
        >
          <c_yicheng
            :meeting_id="props.data?.meeting_id"
            :meeting_schedule_date="state.model?.date"
            :meeting_schedule_id="state.model?.id"
            :search="state.search"
          />
        </div>
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 1 && state.model?.id"
        >
          <c_renyuan
            :meeting_id="props.data?.meeting_id"
            :meeting_schedule_id="state.model?.id"
            :meeting_schedule_name="state.model?.name"
            :search="state.search"
          />
        </div>
        <div
          style="animation: fadeIn 0.8s 0.02s ease backwards"
          class="h-full w-full shrink-0"
          v-if="state.nav_index == 2 && state.model?.id"
        >
          <c_zuoxi
            :meeting_id="props.data?.meeting_id"
            :meeting_schedule_id="state.model?.id"
            :search="state.search"
          />
        </div>
      </div>
    </div>
    <el-dialog
      v-model="state.showEdit"
      title="编辑日程"
      class="c-el-dialog"
      :before-close="
        () => {
          state.showEdit = false;
        }
      "
    >
      <c_edit
        :id="state.model?.id"
        :meeting_id="props.meeting_id"
        @close="
          state.showEdit = false;
          onLoad();
        "
      />
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { meeting_schedule_detail } from "@/http/meeting";

import c_yicheng from "./Detail/YiCheng/List.vue";
import c_renyuan from "./Detail/RenYuan/List.vue";
import c_zuoxi from "./Detail/ZuoXi/Index.vue";

import c_edit from "./Info.vue";

export default {
  props: {
    data: Object,
  },
  components: {
    c_yicheng,
    c_renyuan,
    c_zuoxi,
    c_edit,
  },
  setup(props) {
    const state = reactive({
      nav_index: 0,
      model: {},
    });
    onMounted(() => {
      state.search = props.data?.search;
      onLoad();
    });
    const onLoad = () => {
      if (props.data?.id) {
        meeting_schedule_detail(props.data?.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data || {};
          }
        });
      }
    };

    return { state, props };
  },
};
</script>

<style lang="less" scoped></style>
